const DeviceReplacement = {
  DeviceReplacement: {
    toDoText: 'Przed rozpoczęciem wymiany należy upewnić się, że wykonano następujące kroki',
    toDoListItems: [
      'Odłącz urządzenie, które ma zostać wymienione',
      'Podłącz urządzenie zastępcze',
      'Skonfiguruj urządzenie zastępcze'
    ],
    install_replacement: {
      submitFirstStep: 'Pobierz szczegóły',
      hems_device_api_fault:
        'Jeśli próbujesz zastąpić aktywne obciążenie innej firmy, ale nie widzisz go w rozwijanym menu, przeładuj stronę.',
      labelOldDevice: 'Szczegóły starego urządzenia',
      labelNewDevice: 'Szczegóły nowego urządzenia',
      submitSecondStep: 'Potwierdź wymianę',
      warningText:
        'W przypadku, gdy dane urządzenia są nieprawidłowe lub w innej sprawie, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >kliknij tutaj</a>, aby wrócić',
      DeviceTypes: {
        EVSE: 'IQ ER EVSE',
        ENERGY_METER: 'Licznik energii',
        SG_READY_GATEWAY: 'Przekaźnik SG Ready',
        MICROINVERTER: 'Mikroinwerter',
        AC_BATTERY: 'Bateria AC',
        selectDeviceType: 'wybierz typ urządzenia'
      }
    },
    replace_gateway: {
      submitFirstStep: 'Wymień IQ Energy Router',
      hems_device_api_fault:
        'Jeśli próbujesz zastąpić aktywny IQ Energy Router, ale nie widzisz go na liście rozwijanej, przeładuj stronę.',
      submitSecondStep: 'Wymień IQ Energy Router',
      labelOldDevice: 'Szczegóły starego IQ ER',
      labelNewDevice: 'Szczegóły nowego IQ ER',
      warningText:
        'W przypadku, gdy dane urządzenia są nieprawidłowe lub w innej sprawie, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >kliknij tutaj</a>, aby wrócić',
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        IQ_GATEWAY: 'IQ Gateway',
        selectDeviceType: 'Wybierz typ bramki'
      }
    },
    alert: {
      footerMessage: 'Jeśli problem nie ustąpi, skontaktuj się z działem obsługi klienta Enphase.',
      requestTimedOut: {
        mainMessage: 'Upłynął limit czasu żądania',
        subMessage: 'Spróbuj ponownie później'
      },
      multipleDeviceFound: {
        mainMessage: 'Wymiana nie jest obsługiwana',
        subMessageIqErEvse:
          'W lokalizacji wykryto więcej niż 1 urządzenia EVSE IQ ER. Wymiana nie może być obsługiwana dla tego typu konfiguracji lokalizacji.',
        subMessageEnergyMeter:
          'W lokalizacji wykryto więcej niż 1 liczniki energii. Wymiana nie może być obsługiwana dla tego typu konfiguracji lokalizacji.',
        subMessageSgReadyRelay:
          'W lokalizacji wykryto więcej niż 1 przekaźniki SG Ready. Wymiana nie może być obsługiwana dla tego typu konfiguracji lokalizacji.'
      },
      iqErOffline: {
        mainMessage: 'IQ ER nie raportuje',
        subMessage: 'Upewnij się, że IQ Energy Router jest zasilany i podłączony do Internetu.'
      },
      deviceNotOffline: {
        mainMessage: 'Podłączono stare urządzenie',
        subMessage: 'Wykryto połączenie ze starym urządzeniem. Odłącz stare urządzenie i ponownie zainicjuj wymianę.'
      },
      deviceReplacementInProgress: {
        mainMessage: 'Trwa już wymiana urządzenia tego typu'
      },
      deviceNotFound: {
        mainMessage: 'Nowe urządzenie nie zostało wykryte',
        subMessage:
          'Nie znaleziono danych nowego urządzenia. Upewnij się, że nowe urządzenie jest podłączone do Internetu i skonfigurowane.'
      },
      invalidRmaStatusId: {
        mainMessage: 'Wymiana nie powiodła się ',
        subMessage: 'Wymiana nie powiodła się z powodu nieznanego statusu wymiany'
      },
      activationDuplicateSite: {
        mainMessage: 'Wymiana nie powiodła się',
        subMessage: 'Wymiana nie powiodła się, ponieważ nowy IQ Energy Router jest już aktywny'
      },
      authPending: {
        mainMessage: 'Wymiana nie powiodła się',
        subMessage: 'Wymiana nie powiodła się, ponieważ istniejący IQ Energy Router nie został jeszcze autoryzowany'
      },
      invalidIqEnergyRouter: {
        mainMessage: 'Wymiana nie powiodła się',
        subMessage: 'Wymiana nie powiodła się, ponieważ wprowadzony numer seryjny IQ Energy Router jest nieprawidłowy'
      },
      hemsDevicesNotDiscovered: {
        mainMessage: 'Wymiana nie powiodła się',
        subMessage: 'Wymiana nie powiodła się, ponieważ nie znaleziono wcześniej wykrytych urządzeń HEMS innych firm'
      },
      iqGatewayNotDiscovered: {
        mainMessage: 'Wymiana nie powiodła się',
        subMessage: 'Wymiana nie powiodła się, ponieważ IQ Gateway nie została jeszcze wykryta przez IQ Energy Router'
      },
      authInitFailed: {
        mainMessage: 'Wymiana nie powiodła się',
        subMessage: 'Wymiana nie powiodła się, ponieważ autoryzacja urządzenia nie została zainicjowana'
      },
      invalidDeviceType: {
        mainMessage: 'Typ urządzenia jest nieprawidłowy dla wymiany',
        subMessage: 'Przed wysłaniem żądania upewnij się, że wybrano prawidłowy typ urządzenia.'
      },
      invalidSite: {
        mainMessage: 'Nieobsługiwany typ lokalizacji',
        subMessage: 'Konfiguracja lokalizacji nie obsługuje tej wymiany'
      },
      invalidDevice: {
        mainMessage: 'Stary identyfikator urządzenia jest nieprawidłowy',
        subMessage: 'Wymiana nie jest obsługiwana dla tego urządzenia'
      },
      invalidDeviceUid: {
        mainMessage: 'Stary i nowy identyfikator urządzenia są takie same',
        subMessage: 'Wymiana nie jest obsługiwana dla tego urządzenia'
      },
      deviceReplacementCompleted: {
        mainMessage: 'Wymiana zakończona',
        subMessage:
          'Jeśli trwa walidacja funkcjonalna nowego urządzenia, należy ją przeprowadzić za pomocą aplikacji Enphase Installer Application (ITK).'
      },
      itkSuccessMessage: {
        iqErEvse: 'EV Charger został pomyślnie wymieniony',
        energyMeter: 'Energy meter został pomyślnie wymieniony',
        sgReadyRelay: 'SG Ready Relay został pomyślnie wymieniony',
        iqEnergyRouter: 'Router IQ Energy został pomyślnie wymieniony'
      },
      fetchingDeviceDetailsLoader: { subMessage: 'Pobieranie szczegółów urządzenia' },
      initiatingReplacementLoader: { subMessage: 'Rozpoczęcie wymiany' },
      replacementInprogressLoader: { subMessage: 'Wymiana w toku' }
    }
  }
};

export default DeviceReplacement;
